import { render, staticRenderFns } from "./OfficialHolidaysPlanFloatBtns.vue?vue&type=template&id=58a2f91e&"
import script from "./OfficialHolidaysPlanFloatBtns.vue?vue&type=script&lang=js&"
export * from "./OfficialHolidaysPlanFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports